import axios from "axios";
import config from "../config";
// import store from "../store/store";

let accessToken = '';
let logoutCallback = null;

// 创建 Axios 实例
const httpClient = axios.create({
  baseURL: config.apiBaseUrl, // 替换为你的 API 地址
});

function _post(path, data) {
  // access token 是 okshop 登入後回傳的 access token, 並非 line 的 access token
  return httpClient.post(path,
    {
      data: JSON.stringify(data),
    });
}

function _get(path) {
  return httpClient.get(path);
}

httpClient.interceptors.response.use((response) => {
  // 成功處理 API 回應
  return response;
}, (error) => {
  // 處理錯誤
  console.error('API error', error);
  const status = error?.response?.status;
  if (status) {
    console.error('API error, status: ', status);
  }
  if (status > 400 && status < 500) {
    // 執行登出
    if (logoutCallback) {
      logoutCallback();
    }
  }

  return Promise.reject(error);
});

// 请求拦截器，用于在每个请求前添加逻辑
httpClient.interceptors.request.use(
  (config) => {
    // console.log('config', config);
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // 可以在请求发送前添加 token 等逻辑
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const login = async (data) => _post('/members/login', data)
export const joinMember = async () => _get('/members/join', {});
export const getMemberInfo = async () => _get('/members/info');
export const updateMemberInfo = async (data) => _post('/members/update', data);
export const deleteAddress = async (data) => _post('/members/address_del', data)
export const getCities = async () => _get('/members/get_cities');
export const getCityAreas = async () => _get('/members/get_cityareas');
export const getStoreInfo = () => _get('/members/store_info');
export const pointHistory = async (data) => _post('/point_report/point_history', data)
export const memberPreDeduct = async (data) => _post('/point_report/member_pre_deduct', data)
export const getConsumptionInfo = async () => _post('/orders_history/consumption_info')
export const ordersHistory = async (data) => _post('/orders_history', data)
export const storeChange = (data) => _post('/members/change', data)
export const setAccessToken = (value) => accessToken = value;
export const setLogoutCallback = (callback) => logoutCallback = callback;
export const getStoreCoupons = async (data) => _post('/coupons', data)
export const getCouponInfo = async (data) => _post('/coupons/coupon_info', data)
export const getMemberCoupons = async (data) => _post('/coupons/member_coupons', data)
export const getMemberCouponInfo = async (data) => _post('/coupons/member_coupon_info', data)
export const claimCoupon = async (data) => _post('/coupons/get_coupon', data)
export const createOnlineOrder = async (data) => _post('online_orders/create', data)
export const directPrint = async (data) => _post('/members/direct_print', data)
export const getOnlineOrderInfo = async (data) => _post('online_orders/info', data)
export const getOnlineOrderList = async (data) => _post('online_orders/info_list', data)
export const cancelOnlineOrder = async (data) => _post('online_orders/cancel', data)
export const getProductImages = async (data) => _post('product_images/list', data)
export const getPaymentMethods = async (data) => _post('payments/store_payment_methods_info_list_web', data)
export const getPaymentMethodByTypeAndId = async (data) => _post('payments/store_payment_methods_info_web', data)
export const linePayRequest = async (data) => _post('payments/linepay_request', data)
export const linePayConfirm = async (data) => _post('payments/linepay_confirm', data)
export const linePayCancel = async (data) => _post('payments/linepay_cancel', data)
export const getProductDescriptions = async (data) => _post('/product_desc/list_web', data)
export const getRewardCardList = async (data) => _post('/reward_point/web/reward_card_list', data)
export const getRewardPointProductsList = async (data) => _post('/reward_point/web/reward_point_products_list', data)
export const getMemberTotalRewardPoints = async (data) => _post('/reward_point/web/member_total_reward_points', data)
export const getMemberRewardPointsHistory = async (data) => _post('/reward_point/web/member_reward_points_history', data)
export const getStoreServicesList = async () => _post('/stores/web/store_services_list')
export const getMemberStores = async (data) => _post('/members/stores', data)

// 商品保管 / 領取 API
export const getDepositProductsInfoList = async (data) => _post('/deposit_prods/web/deposit_prods_info_list', data)
export const getDepositProductsLogList = async (data) => _post('/deposit_prods/web/deposit_prods_log_list', data)

// Menu Hive API
const _menuHiveParams = { menu_id: '0', page: 0, page_size: 999 }
export const getMenuHiveCategories = async () => _post('/menu_hive/web/goods_categories_list', _menuHiveParams)
export const getMenuHiveProducts = async () => _post('/menu_hive/web/products_list', _menuHiveParams)
export const getMenuHiveProductSpecs = async () => _post('/menu_hive/web/product_specs_list', _menuHiveParams)
export const getMenuHiveCombos = async () => _post('/menu_hive/web/combo_list', _menuHiveParams)
export const getMenuHiveComboSubs = async () => _post('/menu_hive/web/combo_subs_list', _menuHiveParams)
export const getMenuHiveComboSubAlt = async () => _post('/menu_hive/web/combo_sub_alt_list', _menuHiveParams)
export const getMenuHiveComboSubAny = async () => _post('/menu_hive/web/combo_sub_any_list', _menuHiveParams)
export const getMenuHiveSheetSpecArrangements = async () => _post('/menu_hive/web/sheet_spec_arrangements_list', _menuHiveParams)
export const getMenuHiveServeAreas = async () => _post('/menu_hive/web/serve_areas_list', _menuHiveParams)
export const getMenuHiveServeTables = async () => _post('/menu_hive/web/serve_tables_list', _menuHiveParams)
export const getMenuHiveStockItems = async () => _post('/menu_hive/web/stock_items_list', _menuHiveParams)

// 店家圖片 API
export const getStoreFileList = async () => _get('/stores/web/files')
export const downloadStoreFile = async (fileName) => {
  const formData = new FormData();
  formData.append('data', JSON.stringify({ filename: fileName }));

  return httpClient.post('/stores/web/download', formData, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
